import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const TARGETS_API_URL = "agency/admin/targets/";

export const fetchTargets = createAsyncThunk(
  "targets/fetchTargets",
  async (params = {}, thunkAPI) => {
    try {
      const state = thunkAPI.getState();
      const token = state.auth.token;

      if (!token) {
        return null;
      }

      /* Only the keys that carry a value are sent - an empty filter must
         not go out as `target_type=` and narrow the result set to nothing. */
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.page_size) queryParams.append("page_size", params.page_size);
      if (params.start_date) queryParams.append("start_date", params.start_date);
      if (params.end_date) queryParams.append("end_date", params.end_date);
      if (params.target_type) queryParams.append("target_type", params.target_type);
      if (params.portfolio) queryParams.append("portfolio", params.portfolio);

      const queryString = queryParams.toString();
      const url = queryString ? `${TARGETS_API_URL}?${queryString}` : TARGETS_API_URL;

      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch targets"
      );
    }
  }
);

const initialState = {
  targets_data: null,
  targets_loading: false,
  targets_error: null,
};

const targetSlice = createSlice({
  name: "targets",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTargets.pending, (state) => {
        state.targets_loading = true;
        state.targets_error = null;
      })
      .addCase(fetchTargets.fulfilled, (state, action) => {
        state.targets_loading = false;
        state.targets_data = action.payload || null;
      })
      .addCase(fetchTargets.rejected, (state, action) => {
        state.targets_loading = false;
        state.targets_data = null;
        state.targets_error = action.payload;
      });
  },
});

export default targetSlice.reducer;
